// extracted by mini-css-extract-plugin
export var parcelRow = "_rs-0";